import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import pt from 'date-fns/locale/pt-BR';
import { isSameDay } from 'date-fns';

import * as S from './styles';
import DatePickerHeader from './DatePickerHeader';
import { ScheduleItemProps } from '../../models/Schedule';
import ContainerModal from '../ContainerModal';
import Button from '../Button';
import LoadingOverlay from '../LoadingOverlay';
import { isSameMonth } from 'date-fns';

registerLocale('pt-BR', pt);

type DatePickerModalProps = {
  schedule?: ScheduleItemProps;
  selectedDate: Date | null;
  setSelectedDate: (date: Date | null) => void;
  displayDates: Date[] | undefined;
  setDisplayDates: React.Dispatch<React.SetStateAction<Date[]>>;

  displayDatesPicker: Date[] | undefined;
  onMonthChange: (date: Date) => Promise<void>;
  isOpen: boolean;
  setIsOpen: (visible: boolean) => void;
  loading: boolean;

  loadDates: (baseDate: Date) => Promise<void>;
};

export const ModalDatePicker = ({
  selectedDate,
  setSelectedDate,
  displayDates,
  setDisplayDates,
  displayDatesPicker,
  onMonthChange,
  isOpen,
  setIsOpen,
  loading,
  loadDates
}: DatePickerModalProps) => {
  const firstDateWithSlot = displayDates?.length ? displayDates[0] : undefined;

  const handleSelectDate = (date: Date) => {
    setDisplayDates(dates => {
      const displayDatesSummarized = dates?.slice(0, 3);
      if (displayDatesSummarized?.length) {
        if (!displayDatesSummarized.some(item => isSameDay(item, date))) {
          const displayDatesSlice = dates?.slice(0, 2);

          if (displayDatesSlice) return [...displayDatesSlice, date];
        }
      }
      return displayDatesSummarized;
    });

    setSelectedDate(date);
  };

  React.useEffect(() => {
    if (selectedDate && displayDatesPicker?.length)
      if (!isSameMonth(selectedDate, displayDatesPicker[1])) {
        const dateNow = new Date();

        if (isSameMonth(dateNow, selectedDate)) loadDates(dateNow);
        else loadDates(selectedDate);
      }
  }, [selectedDate]);

  return (
    <ContainerModal
      visible={isOpen}
      onClose={() => setIsOpen(false)}
      withoutCloseButton
      childrenFooter={
        <>
          <Button title="Pronto" onClick={() => setIsOpen(false)} />
          <S.ButtonClose tertiary title="Fechar" onClick={() => setIsOpen(false)} />
        </>
      }
    >
      <S.DatePickerWrapper>
        <DatePicker
          calendarClassName="datePicker"
          locale="pt-BR"
          selectsStart={false}
          // openToDate={firstDateWithSlot}
          showPreviousMonths={false}
          renderCustomHeader={props => <DatePickerHeader {...props} initialDate={firstDateWithSlot} />}
          selected={selectedDate}
          onChange={handleSelectDate}
          inline
          includeDates={displayDatesPicker}
          onMonthChange={onMonthChange}
          placeholderText="Selecione a data."
        />
      </S.DatePickerWrapper>
      <LoadingOverlay loading={loading} />
    </ContainerModal>
  );
};
